// Environment imports
import { environment } from '../../environments/environment';

export class UserActivity {
    readonly portalType = 'B'; // B stands for Board Portal
    readonly host = environment.userActivityHostApiUrl;

    userId: string;
    clientIP: string;
    serverName: string;
    alias: string;
    route: string;
    activity: string;
    dateTimeStamp: Date;
    communityId: number;
    additionalInfo: string;
    screenSize: string;
    browser: string;
    browserVersion: string;
    operatingSystem: string;
    osVersion: string;
    device: string;
    userAgent: string;
}
